class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperElement = this.querySelector('.main-slider');
    this.swiperElement2 = this.querySelector('.thumbs-slider');
    this.arrowPrev = this.querySelector('.swiper-button-prev');
    this.arrowNext = this.querySelector('.swiper-button-next');
    // Properly convert string "true"/"false" to boolean
    this.isQuiz = this.dataset.quiz === 'true';
  }

  connectedCallback() {
    this.initializeSwiper();
    
    // Disable Fancybox in quiz mode by removing data-fancybox attributes
    if (this.isQuiz) {
      this.disableFancyboxInQuiz();
    } else {
      // Initialize Fancybox only for non-quiz mode
      this.initializeFancybox();
    }
  }

  disableFancyboxInQuiz() {
    // Remove data-fancybox attributes to prevent zoom clicks in quiz mode
    const fancyboxElements = this.querySelectorAll('[data-fancybox="gallery"]');
    fancyboxElements.forEach(element => {
      element.removeAttribute('data-fancybox');
      element.style.cursor = 'grab';
    });
  }

  disableSlideClicks() {
    const slides = this.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      slide.style.pointerEvents = 'none';
    });
  }

  initializeFancybox() {
    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: false,
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close'],
        },
      },
      enabled: true,
      Carousel: {
        Navigation: true,
      },
      on: {
        setIdle: (fancybox) => {
          fancybox.close();
        },
      },
    });
  }

  initializeSwiper() {
    let initialIndex = parseInt(this.dataset.startindex) || 0;

    // Initialize thumbs slider only if not in quiz mode
    if (!this.isQuiz) {
      this.galleryThumbs = new Swiper(this.swiperElement2, {
        freeMode: true,
        watchSlidesProgress: true,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          992: {
            slidesPerView: 4,
          },
        },
      });
    }

    // Configure main swiper based on mode
    const swiperConfig = {
      loop: true,
      autoHeight: true,
      spaceBetween: 10,
      slidesPerView: this.isQuiz ? 1.3 : 'auto',
      initialSlide: initialIndex,
      grabCursor: true,
      navigation: {
        nextEl: this.arrowNext,
        prevEl: this.arrowPrev,
      },
    };

    // Add thumbs only if not in quiz mode
    if (!this.isQuiz && this.galleryThumbs) {
      swiperConfig.thumbs = {
        swiper: this.galleryThumbs,
      };
    }

    this.swiper = new Swiper(this.swiperElement, swiperConfig);
  }
}

customElements.define('swiper-component', SwiperComponent);
